<div class="min-h-screen bg-gray-50">
  <!-- Widget Dashboard for users who have seen it or prefer it -->
  @if (showWidgetDashboard()) {
  <app-dashboard-widgets></app-dashboard-widgets>

  <!-- Switch back to traditional -->
  <div class="fixed bottom-6 right-6 z-50">
    <button
      (click)="switchToTraditional()"
      class="inline-flex items-center px-4 py-2 bg-white text-gray-700 text-sm font-medium rounded-full shadow-lg border border-gray-200 hover:bg-gray-50 transition-all duration-200"
      title="Voltar ao dashboard tradicional"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        class="mr-2"
      >
        <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" />
        <line x1="7" y1="7" x2="7" y2="17" />
        <line x1="17" y1="7" x2="17" y2="17" />
        <line x1="7" y1="12" x2="17" y2="12" />
      </svg>
      Dashboard Tradicional
    </button>
  </div>
  } @else {
  <!-- Traditional Dashboard -->
  <div class="p-4 md:p-6">
    <div class="max-w-7xl mx-auto space-y-6">
      <!-- Header Section -->
      <div
        class="flex flex-col md:flex-row md:items-center md:justify-between gap-4"
      >
        <div class="space-y-1">
          <h1 class="text-2xl md:text-3xl font-bold text-gray-900">
            {{ getWelcomeMessage() }}, {{ username() }}!
          </h1>
          @if (currentProfile()) {
          <div class="flex items-center gap-2">
            <p class="text-gray-600">{{ currentProfile()!.description }}</p>
            <span
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-800"
            >
              {{ currentProfile()!.displayName }}
            </span>
          </div>
          }
        </div>

        <!-- Switch to Widgets -->
        <div class="flex gap-3">
          <app-share-button
            variant="secondary"
            text="Compartilhar"
            title="Compartilhar dashboard"
          ></app-share-button>
          <button
            (click)="switchToWidgets()"
            class="inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white text-sm font-medium rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all duration-200 shadow-lg"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              class="mr-2"
            >
              <rect x="3" y="3" width="7" height="7" />
              <rect x="14" y="3" width="7" height="7" />
              <rect x="14" y="14" width="7" height="7" />
              <rect x="3" y="14" width="7" height="7" />
            </svg>
            🚀 Dashboard Inovador
          </button>
        </div>
      </div>

      <!-- Traditional KPI Cards -->
      @if (kpiData().length > 0) {
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        @for (kpi of kpiData(); track kpi.title) {
        <div class="bg-white rounded-lg shadow p-6">
          <div class="flex items-center justify-between">
            <div class="space-y-2">
              <p class="text-sm font-medium text-gray-600">{{ kpi.title }}</p>
              <p class="text-2xl font-bold text-gray-900">{{ kpi.value }}</p>
              @if (kpi.change) {
              <div class="flex items-center gap-1">
                @if (kpi.changeType === 'increase') {
                <span class="text-green-600 text-sm">↗ +{{ kpi.change }}%</span>
                } @else {
                <span class="text-red-600 text-sm">↘ -{{ kpi.change }}%</span>
                }
              </div>
              }
            </div>
          </div>
        </div>
        }
      </div>
      }

      <!-- Legacy Stats Grid (fallback) -->
      @if (stats().length > 0) {
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        @for (stat of stats(); track stat.title) {
        <div class="bg-white rounded-lg shadow p-6">
          <div class="flex items-center justify-between">
            <div class="space-y-2">
              <p class="text-sm font-medium text-gray-600">{{ stat.title }}</p>
              <p class="text-xs text-gray-500">{{ stat.subtitle }}</p>
              <p class="text-2xl font-bold text-gray-900">{{ stat.value }}</p>
              @if (stat.change) {
              <div class="flex items-center gap-1 text-sm">
                <span
                  class="material-icons text-sm"
                  [class]="
                    stat.changeClass === 'positive'
                      ? 'text-green-600'
                      : stat.changeClass === 'negative'
                      ? 'text-red-600'
                      : 'text-gray-600'
                  "
                >
                  {{ stat.changeIcon }}
                </span>
                <span
                  [class]="
                    stat.changeClass === 'positive'
                      ? 'text-green-600'
                      : stat.changeClass === 'negative'
                      ? 'text-red-600'
                      : 'text-gray-600'
                  "
                >
                  {{ stat.change }}
                </span>
              </div>
              }
            </div>
            @if (stat.icon) {
            <span class="material-icons text-3xl text-primary-600">{{
              stat.icon
            }}</span>
            }
          </div>
        </div>
        }
      </div>
      }

      <!-- Main Content Grid -->
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <!-- Sales Chart -->
        <div class="lg:col-span-2">
          <div class="bg-white rounded-lg shadow">
            <div class="p-6">
              <div class="flex items-center justify-between mb-6">
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">
                    Vendas dos Últimos Meses
                  </h3>
                  <p class="text-sm text-gray-600">
                    Acompanhe o desempenho das suas vendas
                  </p>
                </div>
                <span
                  class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800"
                >
                  Mensal
                </span>
              </div>

              <!-- Mock Chart -->
              <div class="relative h-64">
                <div class="flex items-end justify-between h-full px-4 pb-8">
                  <div class="flex flex-col items-center space-y-2">
                    <div class="bg-primary-600 rounded-t w-8 h-20"></div>
                    <span class="text-xs text-gray-600">Jan</span>
                    <span class="text-xs font-medium">R$ 1.250</span>
                  </div>
                  <div class="flex flex-col items-center space-y-2">
                    <div class="bg-primary-600 rounded-t w-8 h-32"></div>
                    <span class="text-xs text-gray-600">Fev</span>
                    <span class="text-xs font-medium">R$ 1.890</span>
                  </div>
                  <div class="flex flex-col items-center space-y-2">
                    <div class="bg-primary-600 rounded-t w-8 h-16"></div>
                    <span class="text-xs text-gray-600">Mar</span>
                    <span class="text-xs font-medium">R$ 980</span>
                  </div>
                  <div class="flex flex-col items-center space-y-2">
                    <div class="bg-primary-600 rounded-t w-8 h-24"></div>
                    <span class="text-xs text-gray-600">Abr</span>
                    <span class="text-xs font-medium">R$ 1.560</span>
                  </div>
                  <div class="flex flex-col items-center space-y-2">
                    <div class="bg-secondary-500 rounded-t w-8 h-40"></div>
                    <span class="text-xs text-gray-600">Mai</span>
                    <span class="text-xs font-medium">R$ 2.100</span>
                  </div>
                  <div class="flex flex-col items-center space-y-2">
                    <div class="bg-primary-600 rounded-t w-8 h-20"></div>
                    <span class="text-xs text-gray-600">Jun</span>
                    <span class="text-xs font-medium">R$ 1.200</span>
                  </div>
                </div>
              </div>

              <!-- Chart Insights -->
              <div class="grid grid-cols-2 gap-4 mt-6 pt-6 border-t">
                <div class="text-center">
                  <p class="text-2xl font-bold text-green-600">+18%</p>
                  <p class="text-sm text-gray-600">vs mês anterior</p>
                </div>
                <div class="text-center">
                  <p class="text-2xl font-bold text-primary-600">R$ 8.980</p>
                  <p class="text-sm text-gray-600">Total semestre</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Recent Activities -->
        <div>
          <div class="bg-white rounded-lg shadow">
            <div class="p-6">
              <div class="flex items-center justify-between mb-6">
                <h3 class="text-lg font-semibold text-gray-900">
                  Atividades Recentes
                </h3>
                <button
                  class="text-sm text-primary-600 hover:text-primary-700"
                  (click)="navigateTo('/activities')"
                >
                  Ver todas
                </button>
              </div>

              <div class="space-y-4">
                @for (activity of activities(); track activity.id) {
                <div
                  class="flex items-start space-x-3 p-3 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer"
                  (click)="activity.route && navigateTo(activity.route)"
                >
                  <div class="flex-shrink-0">
                    <div
                      class="w-10 h-10 rounded-lg flex items-center justify-center"
                      [class]="
                        activity.iconType === 'success'
                          ? 'bg-green-100 text-green-600'
                          : activity.iconType === 'warning'
                          ? 'bg-yellow-100 text-yellow-600'
                          : activity.iconType === 'accent'
                          ? 'bg-accent-100 text-accent-600'
                          : 'bg-primary-100 text-primary-600'
                      "
                    >
                      <span class="material-icons text-sm">{{
                        activity.icon
                      }}</span>
                    </div>
                  </div>
                  <div class="flex-1 min-w-0">
                    <p class="text-sm font-medium text-gray-900">
                      {{ activity.title }}
                    </p>
                    <p class="text-xs text-gray-600 mt-1">
                      {{ activity.description }}
                    </p>
                    <p class="text-xs text-gray-500 mt-1">
                      {{ activity.timestamp }}
                    </p>
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Quick Actions -->
      @if (quickActions().length > 0) {
      <div>
        <h3 class="text-lg font-semibold text-gray-900 mb-4">Ações Rápidas</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          @for (action of quickActions(); track action.title) {
          <div
            class="bg-white rounded-lg shadow p-6 hover:shadow-md transition-shadow cursor-pointer"
            (click)="onQuickActionClick(action)"
          >
            <div class="text-center space-y-3">
              <div
                class="w-12 h-12 bg-primary-100 text-primary-600 rounded-lg flex items-center justify-center mx-auto"
              >
                <span class="material-icons text-xl">{{ action.icon }}</span>
              </div>
              <div>
                <h4 class="font-medium text-gray-900">{{ action.title }}</h4>
                <p class="text-sm text-gray-600 mt-1">
                  {{ action.description }}
                </p>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>
  }
</div>
